<div class="rn-update-list">
  <div class="rn-update-list__header">
    <h3 class="rn-update-list__title">Release updates</h3>
    <app-admin-button variant="secondary" type="button" (click)="addUpdate()">Add update</app-admin-button>
  </div>

  @if (items().length === 0) {
    <p class="cg-form-help">No update items yet. Add updates to describe what changed in this release.</p>
  } @else {
    <div cdkDropList (cdkDropListDropped)="onReorder($event)">
      @for (item of items(); track item.id; let i = $index) {
        <div cdkDrag class="rn-update-list__item">
          <app-release-update-card
            [item]="item"
            [index]="i"
            (itemChange)="updateAt(i, $event)"
            (remove)="removeAt(i)"
          />
        </div>
      }
    </div>
  }
</div>
